import { Injectable } from '@angular/core';
//import { Http } from '@angular/http';
//import 'rxjs/add/operator/map';

/*
  Generated class for the ApplicationConstants provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class QueryList {

  constructor() {
    
  }

  public all_base_acct_types:string = "SELECT * FROM `base_acct_type` WHERE `status` = '1'"; 
  public all_acct_types:string = "SELECT * FROM `acct_type` WHERE `status` = '1'"; 
  public all_tax_types:string = "SELECT * FROM `tax` WHERE `status` = '1'"; 
  public all_currency:string = "SELECT * FROM `currency` WHERE `status` = '1'";
  public all_itemCat:string = "SELECT * FROM `item_cat` WHERE `status` = '1'"; 
  public all_mainAcct:string = "SELECT * FROM `main_acct` WHERE `status` = '1'"; 
  public all_subAcct:string = "SELECT * FROM `sub_acct` WHERE `status` = '1'";
  public all_country:string = "SELECT * FROM `country` WHERE `status` = '1'";
  public all_unit:string = "SELECT * FROM `unit` WHERE `status` = '1'";
  public all_supplierCat:string = "SELECT * FROM `supplier_category` WHERE `status` = '1'";
  public all_costCenter:string = "SELECT * FROM `cost_center` WHERE `status` = '1'";
  public all_customerCat:string = "SELECT * FROM `customer_category` WHERE `status` = '1'";
  public all_company:string = "SELECT * FROM `company` WHERE `status` = 1";
  public all_city:string = "SELECT * FROM `city` WHERE `status` = '1'";
  public all_thermalPrinter:string = "SELECT * FROM `thermal_printer` WHERE `status` = '1'";
  public all_paymentType:string = "SELECT * FROM `payment_type` WHERE `status` = '1'";
  public all_main_menu:string = "SELECT * FROM `menu` WHERE `display` = 'T' ORDER BY `menu`.`seq` ASC";
  public all_sub_menu:string = "SELECT * FROM `menu_item` WHERE `display` = 'T' ORDER BY `menu_item`.`seq` ASC ";
  public all_empAllowance:string = "SELECT * FROM `emp_allowance` WHERE `status` = '1'";
  public all_invCondList:string = "SELECT * FROM `inv_cond_list` WHERE `status` = '1'";
  public all_itemSubCat:string = "SELECT * FROM `item_subcat` WHERE `status` = '1'"; 
  public all_repEmp:string = "SELECT * FROM `employee` WHERE `is_rep` = '1' AND `status` = '1'";
  public all_branch:string = "SELECT * FROM `branch` WHERE `status` = '1'";
  public all_emp:string = "SELECT * FROM `employee` WHERE `status` = '1'";
  public all_bank:string = "SELECT * FROM `bank_account` WHERE `status` = '1'";
  public all_fixed_asset:string = "SELECT * FROM `fixed_asset` WHERE `status` = '1'";
  public all_store:string = "SELECT * FROM `store` WHERE `status`='1'";
  public all_serv_table:string = "SELECT * FROM `serv_table` WHERE `status` = '1'";
  public all_flavour:string = "SELECT * FROM `flavour` WHERE `status`='1'";
  public acct_config:string = "SELECT * FROM `acct_config` WHERE `status`='1'";
  public all_occupation:string = "SELECT * FROM `occupation` WHERE `status`='1'";
}
